import axios from 'axios';


const api = axios.create({
  baseURL: "https://admin.eesouq.com/api",
  headers: {
    'X-API-KEY': 'TnHMDUZ7nO3T7LusA6XPGbgIHnXu2xEP1emvZZVqz6cMo1NfyKYDNUnDHHLoqZZfyDW1nWCsZPrl5sDjbQizBE0nSG1qUtTYi52R'
  }
});
export default api;